import clsx from "clsx";
import { Loader2 } from "lucide-react";
import { ButtonHTMLAttributes, forwardRef } from "react";

type Variant = "primary" | "secondary" | "danger" | "ghost";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: "sm" | "md" | "lg";
  loading?: boolean;
}

const VARIANT: Record<Variant, string> = {
  primary: "bg-accent text-white hover:bg-blue-500 disabled:bg-blue-900 disabled:text-blue-300",
  secondary: "bg-line text-text hover:bg-gray-700 disabled:opacity-50",
  danger: "bg-red-600 text-white hover:bg-red-500 disabled:opacity-50",
  ghost: "bg-transparent text-text hover:bg-line disabled:opacity-50",
};

const SIZE = { sm: "px-2 py-1 text-xs", md: "px-3 py-1.5", lg: "px-4 py-2 text-base" };

export const Button = forwardRef<HTMLButtonElement, Props>(function Button(
  { variant = "secondary", size = "md", className, loading, disabled, children, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      disabled={disabled || loading}
      className={clsx(
        "rounded transition-colors duration-100 inline-flex items-center justify-center gap-1.5 font-medium",
        VARIANT[variant],
        SIZE[size],
        className,
      )}
      {...rest}
    >
      {loading ? <Loader2 className="animate-spin" size={14} aria-label="Cargando" /> : null}
      {children}
    </button>
  );
});
